module.exports = __webpack_public_path__ + "img/28_85.ae33586b.png";